import { JobApplication } from '../types';

export default function isInPast(job: JobApplication) {
    return new Date(job.dateEndUtc) < new Date();
}
